import { ServiceFetch } from '../service-fetch'

export default class StockRequestListModel extends ServiceFetch {
    getStockRequestListBy = (data) => this.authFetch({
        url: 'stock-request-list/getStockRequestListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}